import { get, fetch, instance, crossDomainReq, source, put, dele } from './axios'
import {url, projectUrl} from './url'
import customer from './customer' //客户等模块获取数据部分移出

const baseUrl = url;
/**
 * 删除http_process 合并到http方法
 * 删除http_url 使用http中fullUrl字段
 * 删除http_download 使用http内responseType字段
 * 删除http_upload 使用http方法postType字段
 * 删除http_mocke 使用http方法
 **/

export default {
    instance,
    source,
    http({
        url,
        params = {},
        type,
        fullUrl, //自定义url字段
        responseType, //dowoload下载使用
        postType, //三种方式 1.formdata: multipart/form-data 2.json: application/json 3.urlencoded: application/x-www-form-urlencoded json形式需要指定，其余可不指定
    }) {
        // let _url = fullUrl ? fullUrl : (basicUrl + url);
        let _url = fullUrl ? fullUrl : url;
        _url = baseUrl + _url;
        let _type = type ? type.toUpperCase() : '';
        if (_type == 'POST') {
            return fetch(_url, params, postType, responseType);
        } else if (_type == 'PUT') {
            return put(_url, params);
        } else if (_type == 'DELETE') {
            return dele(_url, params);
        } else {
            return get(_url, { params: params, responseType });
        }
    },
    http_project({
        url,
        params = {},
        type,
        fullUrl, //自定义url字段
        responseType, //dowoload下载使用
        postType, //三种方式 1.formdata: multipart/form-data 2.json: application/json 3.urlencoded: application/x-www-form-urlencoded json形式需要指定，其余可不指定
    }) {
        // let _url = fullUrl ? fullUrl : (basicUrl + url);
        let _url = fullUrl ? fullUrl : url;
        _url = projectUrl + _url;
        let _type = type ? type.toUpperCase() : '';
        if (_type == 'POST') {
            return fetch(_url, params, postType, responseType);
        } else if (_type == 'PUT') {
            return put(_url, params);
        } else if (_type == 'DELETE') {
            return dele(_url, params);
        } else {
            return get(_url, { params: params, responseType });
        }
    },
    ...customer
}
